import React from 'react';
import { FormattedMessage, useIntl } from '@kyruus/intl';
import { InterpretationSearchTerm } from './InterpretationSearchTerm';
import { type Log, type GetUpdatedSearch } from 'Src/types';
import { SearchLink } from 'Src/types/search';
import { messages } from '../../messages';

interface InterpretationProps {
  totalProviders: number;
  searchTerms: SearchLink[];
  locationFilterName?: string | null;
  log: Log;
  getUpdatedSearch: GetUpdatedSearch;
}

export const Interpretation = ({
  totalProviders,
  searchTerms,
  locationFilterName,
  log,
  getUpdatedSearch
}: InterpretationProps) => {
  const intl = useIntl();
  // Don't link the term if there's only 1, the search can't be refined further.
  const renderAsLink = searchTerms.length > 1;
  const searchTermNodes = searchTerms.map((term) => {
    return (
      <InterpretationSearchTerm
        key={term.display_text}
        renderAsLink={renderAsLink}
        term={term}
        getUpdatedSearch={getUpdatedSearch}
        log={log}
      />
    );
  });
  const messageDescriptor = locationFilterName
    ? messages.foundForInterpretationNear
    : messages.foundForInterpretation;
  return (
    <FormattedMessage
      {...messageDescriptor}
      values={{
        location: locationFilterName,
        providerCount: totalProviders,
        searchTerms: intl.formatList(searchTermNodes, { type: 'conjunction' })
      }}
    />
  );
};
